import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";

export function useStripePortal() {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();

  const openPortal = async () => {
    if (!user) {
      toast.error("You must be logged in to manage your subscription");
      return;
    }

    setIsLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke(
        "create-stripe-portal",
        {
          body: { userId: user.id },
        }
      );

      if (error) {
        toast.error("Failed to open billing portal. Please try again.");
        console.error("Portal error:", error);
        return;
      }

      if (data?.data?.url) {
        window.location.href = data.data.url;
      } else if (data?.url) {
        window.location.href = data.url;
      } else {
        toast.error("No portal URL returned. Please try again.");
      }
    } catch (err: any) {
      toast.error("Something went wrong. Please try again.");
      console.error("Portal error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return { openPortal, isLoading };
}
